import React, { useEffect, useState } from "react";
import { useFiles } from "../files/filesStore";
import { Files } from "../files/Files";
import { Toolbar } from "../tools/Toolbar";
import PreviewScreen from "../preview/Preview";
import { useRoute, Link } from "wouter";
import { getShare, Share, useGetFeatureFlags } from "../api/api";
import { Button } from "react-bootstrap";
import { DownloadSelectionButton } from "../tools/DownloadSelectionButton";
import { useSelection } from "../tools/selectionStore";

export default function SharedApp() {
    const enableShares = useGetFeatureFlags().data?.enable_shares;
    if (enableShares === false) {
        return <>
            Shares are disabled
            <Link to="/">
                <Button>← Home</Button>
            </Link>
        </>;
    }
    if (enableShares === undefined) {
        return <>Loading...</>;
    }
    return <SharedApp_ />

}

function SharedApp_() {
    const [shareData, setShareData] = useState<Share>();
    const hasSelection = useSelection(s => s.selection.length > 0);

    const { id } = useRoute("/share/:id")[1]!

    useEffect(() => {
        (async function () {
            const data = await getShare(id);
            useFiles.getState().hydrateFiles(data.files);
            setShareData(data.share);
        })();
    }, []);

    if (!shareData)
        return <>Loading...</>

    return <>
        <div className="main-content">
            <div>
                <h1>{shareData.name}</h1>
                <div>
                    <p>{shareData.description}</p>
                </div>
                <Files />
            </div>
            <div className="toolbar">
                <div className="toolbar-inner">
                    {hasSelection && <DownloadSelectionButton />}
                </div>
            </div>
        </div>


        <PreviewScreen />
    </>
}